module.exports = __webpack_public_path__ + "img/company-pic.a88128bd.jpg";